import surveyAPI from 'api/base';

import { PostOnboarding } from './types';

export const postOnboarding: PostOnboarding = (data) => {
  return surveyAPI.post('/surveys:onboarding/', data);
};
